
let state = {
  stylePath: 'https://style.81lianpin.com/',
  publicPath: sessionStorage.getItem('publicPath') ? JSON.parse(sessionStorage.getItem('publicPath')) : '',
  platformInfo: sessionStorage.getItem('platformInfo') ? JSON.parse(sessionStorage.getItem('platformInfo')) : {},//平台配置,页面刷新保存到session
  host: '', // 域名
}

export default state



// WEBPACK FOOTER //
// ./src/store/state.js